<template>
  <div class="d-inline-block">
    <!-- Button trigger modal -->
    <button type="button" class="btn btn-outline-primary d-print-none" :disabled="isLoading" @click="show">
      <fa v-if="showIcon" icon="comment-alt" class="mr-1" />
      <span v-if="showText" class="mx-1">Comments</span>
      <span v-if="showCount" class="ml-1 badge badge-danger">{{ count }}</span>
    </button>

    <!-- Modal -->
    <div ref="modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modal" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content" style="max-height: 600px;">
          <div class="modal-header">
            <h5 class="modal-title text-capitalize">{{ subjectType }} Comments</h5>
            <button type="button" class="close" aria-label="Close" @click="hide">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form v-if="canComment">
              <div class="form-group">
                <label for="text" class="col-form-label">Add Comment:</label>
                <textarea v-model="text" class="form-control" :id="getCommentId()" maxlength="10000" rows="5"></textarea>
              </div>
              <button type="button" class="btn btn-primary" :disabled="!text" @click="save">Save Comment</button>
            </form>
            <div class="card my-3" v-for="comment in comments" :key="comment.commentId">
              <div class="card-body py-3">
                <p class="font-italic">{{ comment.text }}</p>
                <p class="mb-0 text-muted">{{ comment.userFullName }} on {{ formatter.date.long(comment.timestamp) }}</p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="hide">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { mapGetters } from "vuex";
import formatter from "@/utils/formatter";

export default {
  props: {
    isLoading: Boolean,
    organizationId: String,
    reportId: String,
    report: Object,

    showText: { type: Boolean, default: true },
    showIcon: { type: Boolean, default: true },
    showCount: { type: Boolean, default: true },

    subjectType: String,
    subjectId: String,
  },
  data() {
    return {
      text: null,
    };
  },
  computed: {
    ...mapGetters("role", ["isReportCommenter", "isInvestigationCreator", "isInvestigationViewer"]),
    formatter: () => formatter,
    canComment() {
      return this.isReportCommenter || this.isInvestigationCreator || this.isInvestigationViewer ? true : false;
    },
    comments() {
      if (!this.report || !this.report.comments) return [];
      var matches = this.report.comments.filter(c => c.subjectType === this.subjectType && c.subjectId == this.subjectId);
      return matches;
    },
    count() {
      return this.comments.length;
    },
  },
  methods: {
    reset() {
      this.text = null;
    },
    show() {
      this.reset();
      $(this.$refs.modal).modal("show");
    },
    hide() {
      $(this.$refs.modal).modal("hide");
    },
    save() {
      const payload = {
        subjectType: this.subjectType,
        subjectId: this.subjectId,
        text: this.text,
      };

      this.$axios
        .put(`/v1/organizations/${this.organizationId}/reports/${this.reportId}/comments`, payload)
        .then(() => {
          this.hide();
          this.reset();
          this.$emit("reload");
        })
        .catch(err => this.$emit("error", err));
    },
    getCommentId() {
      return `text-${this.subjectType}-${this.subjectId}`;
    },
  },
};
</script>
